import React from 'react'
import { useParams } from 'react-router';

// collection
import PDFGenerator from './PDFGenerator/PDFGenerator.collection';

// wrapper
import WithGqlQuery from '../../../wrappers/gql/WithGqlQuery/WithGqlQuery.wrapper'

// gql
import { GET_EQUIPMENT_REQUEST_BY_ID_FOR_PDF } from '../../../graphql/equipmentRequest/equipmentRequest.queries';

const EquipmentRequestPDF = () => {

    const { requestId } = useParams()
    

    return (<div>
        <WithGqlQuery component={PDFGenerator} query={GET_EQUIPMENT_REQUEST_BY_ID_FOR_PDF} variables={{ id: requestId}} />
    </div>)
}

export default EquipmentRequestPDF;